const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search';
const TIMEOUT_MS = 5000;

const MIN_PLACE_RANK = 28;

/**
 * Looks up coordinates for a street address.
 * @param {string} address
 * @param {string} city
 * @returns {Promise<{ latitude: number, longitude: number } | null>}
 */
export async function geocodeAddress(address, city) {
  const query = [address, city].filter(Boolean).join(', ');
  if (!query) return null;

  const params = new URLSearchParams({ q: query, format: 'jsonv2', limit: '1' });
  try {
    const response = await fetch(`${NOMINATIM_URL}?${params}`, { signal: AbortSignal.timeout(TIMEOUT_MS) });
    if (!response.ok) throw new Error(`Nominatim responded ${response.status}`);
    const [match] = await response.json();
    if (!match || match.place_rank < MIN_PLACE_RANK) return null;
    return { latitude: parseFloat(match.lat), longitude: parseFloat(match.lon) };
  } catch (error) {
    console.error('Geocoding failed:', error);
    return null;
  }
}
